// src/components/Instituicoes/PostsList.js

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography, Card, CardContent, CardActions, Button, Grid } from '@mui/material';
import { getPosts } from '../../services/postService'; // Verifique se este serviço está implementado
import { useNavigate } from 'react-router-dom';

const PostsList = ({ instituicaoId }) => {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const data = await getPosts(instituicaoId);
        setPosts(data);
      } catch (error) {
        console.error('Erro ao buscar posts:', error);
        // Implementar feedback ao usuário, por exemplo, notificações
      }
    };

    fetchPosts();
  }, [instituicaoId]);

  const handleViewPost = (postId) => {
    navigate(`/instituicoes/${instituicaoId}/posts/${postId}`);
  };

  return (
    <Grid container spacing={2}>
      {posts.map((post) => (
        <Grid item xs={12} sm={6} md={4} key={post.id}>
          <Card>
            <CardContent>
              <Typography variant="h6">{post.titulo}</Typography>
              <Typography variant="body2">{post.descricao}</Typography>
            </CardContent>
            <CardActions>
              <Button size="small" onClick={() => handleViewPost(post.id)}>
                Ver Mais
              </Button>
            </CardActions>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

PostsList.propTypes = {
  instituicaoId: PropTypes.string.isRequired,
};

export default PostsList;
